var map = {
	"./Gravity.mp3": 195,
	"./Indie-gest.mp3": 786,
	"./Medussa.mp3": 439,
	"./NewBegining.mp3": 765,
	"./Nos Vamos.mp3": 16,
	"./Pianotec.mp3": 434,
	"./Planeta_yo.mp3": 851,
	"./Poppa America.mp3": 760,
	"./Rare Manifestum.mp3": 268,
	"./Semiotico.mp3": 729,
	"./Strange Summer.mp3": 232,
	"./Working Class.mp3": 781,
	"./tanHop.mp3": 0
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;